import { FiscalYearApiClient } from '@/clients/fiscalYearApiClient';
import { FiscalYear, CreateFiscalYearRequest, FiscalYearsResponse, UpdateFiscalYearRequest } from '@/types/fiscalYear';

export class FiscalYearService {
  async getFiscalYears(): Promise<FiscalYearsResponse> {
    return FiscalYearApiClient.getFiscalYears();
  }

  async createFiscalYear(request: CreateFiscalYearRequest): Promise<FiscalYear> {
    return FiscalYearApiClient.createFiscalYear(request);
  }

  async updateFiscalYear(request: UpdateFiscalYearRequest): Promise<FiscalYear> {
    return FiscalYearApiClient.updateFiscalYear(request);
  }

  async closeFiscalYear(fiscalYearId: string): Promise<FiscalYear> {
    return FiscalYearApiClient.closeFiscalYear(fiscalYearId);
  }
}
